import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  AttachmentsDataScope,
  AttachmentsSelectors,
  getAttachmentStoreScope,
} from '@core/attachments-data';
import type { Attachment } from '@core/attachments-types';
import { filterBoolean } from '@core/common-legacy';
import type { Requisition } from '@core/requisitions-types';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class FilesPageDataService {
  private readonly rootData = inject(RootPageDataService);
  private readonly store = inject(Store);

  public requisition$: Observable<Requisition>;
  public attachments$: Observable<Attachment[]>;
  public isLoaded$: Observable<boolean>;

  constructor() {
    const rootData = this.rootData;
    const store = this.store;

    this.requisition$ = rootData.requisition$;
    const requisitionId$ = this.requisition$.pipe(map(requisition => requisition.id));
    const attachmentsScope$ = requisitionId$.pipe(
      map(id => getAttachmentStoreScope(AttachmentsDataScope.Requisition, id)),
    );

    this.attachments$ = attachmentsScope$.pipe(
      switchMap(scope =>
        store
          .select(
            AttachmentsSelectors.entities({
              scope,
            }),
          )
          .pipe(filterBoolean),
      ),
    );
    this.isLoaded$ = attachmentsScope$.pipe(
      switchMap(scope => store.select(AttachmentsSelectors.isLoaded({ scope }))),
    );
  }
}
